// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ryE4R","header":"styles_header__DAEYf","actions":"styles_actions__rAfyT","btn":"styles_btn__G5zZQ","content":"styles_content__6e2+c"};